var _g, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_13_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 33,
    r: 28,
    fill: "#F9EC1A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 33,
    r: 26.5,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.45 34.05C32.45 34.4833 32.4333 34.9333 32.4 35.4C32.4 35.8333 32.4 36.2833 32.4 36.75C31.0667 36.75 29.7 36.75 28.3 36.75C26.9 36.75 25.5167 36.75 24.15 36.75C24.1167 35.3833 24.0833 34 24.05 32.6C24.0167 31.2 23.9833 29.8333 23.95 28.5C27.15 28.2333 29.45 27.8667 30.85 27.4C32.2833 26.9 33 26.2 33 25.3C33 24.5333 32.5833 23.9333 31.75 23.5C30.9167 23.0333 29.8 22.75 28.4 22.65C27.0333 22.5167 25.5 22.6 23.8 22.9C22.1333 23.1667 20.45 23.6333 18.75 24.3C18.75 22.9 18.75 21.5 18.75 20.1C18.75 18.6667 18.75 17.25 18.75 15.85C23.2167 14.7167 27.15 14.3167 30.55 14.65C33.9833 14.9833 36.65 15.9833 38.55 17.65C40.4833 19.2833 41.45 21.5167 41.45 24.35C41.45 26.1167 41.0667 27.6333 40.3 28.9C39.5333 30.1333 38.4667 31.1667 37.1 32C35.7667 32.8333 34.2167 33.5167 32.45 34.05ZM28.3 49.8C27.3333 49.8 26.4333 49.5667 25.6 49.1C24.8 48.6333 24.1667 48 23.7 47.2C23.2333 46.4 23 45.5333 23 44.6C23 43.6667 23.2333 42.8167 23.7 42.05C24.1667 41.25 24.8 40.6167 25.6 40.15C26.4333 39.6833 27.3333 39.45 28.3 39.45C29.2667 39.45 30.1333 39.6833 30.9 40.15C31.7 40.6167 32.3333 41.25 32.8 42.05C33.3 42.8167 33.55 43.6667 33.55 44.6C33.55 45.5333 33.3 46.4 32.8 47.2C32.3333 48 31.7 48.6333 30.9 49.1C30.1333 49.5667 29.2667 49.8 28.3 49.8Z",
    fill: "#BC1614"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13_8",
    x: 0,
    y: 5,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13_8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.84cec9d81e75f3fc8bf1facf60fb1f34.svg";
export { ForwardRef as ReactComponent };